const getChannelNameFromId = ({ channelId, channels, }) => {
    if (!channels) {
        return null;
    }
    const selectedChannel = channels.find((channel) => channel.id === channelId);
    return selectedChannel ? selectedChannel.name : null;
};
export { getChannelNameFromId };
